export default "__VITE_ASSET__ZWabbBOu__"